import { Component, Input } from '@angular/core';

export interface Sign {
  id: string;
  name: string;
  video: string;
  thumb: string;
  thumbGif: string;
}

@Component({
  selector: 'sign-viewer[sign]',
  template: `<h2>{{sign.name}}</h2><video controls width="320" height="568" autoplay>
  <source src="/{{sign.id}}/{{sign.video}}"
          type="video/mp4">

  Sorry, your browser doesn't support embedded videos.
</video>`,
})
export class SignViewerComponent {
  @Input()
  sign!: Sign;
}
